import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './monthly-product-usage.reducer';

export const MonthlyProductUsageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const monthlyProductUsageEntity = useAppSelector(state => state.monthlyProductUsage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="monthlyProductUsageDetailsHeading">
          <Translate contentKey="crawlerBackendApp.monthlyProductUsage.detail.title">MonthlyProductUsage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{monthlyProductUsageEntity.id}</dd>
          <dt>
            <span id="averagePrice">
              <Translate contentKey="crawlerBackendApp.monthlyProductUsage.averagePrice">Average Price</Translate>
            </span>
          </dt>
          <dd>{monthlyProductUsageEntity.averagePrice}</dd>
          <dt>
            <span id="from">
              <Translate contentKey="crawlerBackendApp.monthlyProductUsage.from">From</Translate>
            </span>
          </dt>
          <dd>
            {monthlyProductUsageEntity.from ? (
              <TextFormat value={monthlyProductUsageEntity.from} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="until">
              <Translate contentKey="crawlerBackendApp.monthlyProductUsage.until">Until</Translate>
            </span>
          </dt>
          <dd>
            {monthlyProductUsageEntity.until ? (
              <TextFormat value={monthlyProductUsageEntity.until} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="monthlyUsage">
              <Translate contentKey="crawlerBackendApp.monthlyProductUsage.monthlyUsage">Monthly Usage</Translate>
            </span>
          </dt>
          <dd>{monthlyProductUsageEntity.monthlyUsage}</dd>
          <dt>
            <span id="beginStand">
              <Translate contentKey="crawlerBackendApp.monthlyProductUsage.beginStand">Begin Stand</Translate>
            </span>
          </dt>
          <dd>
            {monthlyProductUsageEntity.beginStand ? (
              <TextFormat value={monthlyProductUsageEntity.beginStand} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endStand">
              <Translate contentKey="crawlerBackendApp.monthlyProductUsage.endStand">End Stand</Translate>
            </span>
          </dt>
          <dd>
            {monthlyProductUsageEntity.endStand ? (
              <TextFormat value={monthlyProductUsageEntity.endStand} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.monthlyProductUsage.product">Product</Translate>
          </dt>
          <dd>{monthlyProductUsageEntity.product ? monthlyProductUsageEntity.product.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/monthly-product-usage" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/monthly-product-usage/${monthlyProductUsageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MonthlyProductUsageDetail;
